const FeatureBannerMap = new Map();

FeatureBannerMap.set(1, '/shopPromotion');
FeatureBannerMap.set(2, '/sellCrop');
FeatureBannerMap.set(3, '/bahiKhata');
FeatureBannerMap.set(4, '/cropCalendar');
FeatureBannerMap.set(5, '/rake');
FeatureBannerMap.set(6, '/expenseManager');
FeatureBannerMap.set(7, '/mandiRate');
FeatureBannerMap.set(8, '/distributor');
FeatureBannerMap.set(9, '/community');
FeatureBannerMap.set(10, '/addFarmer');
FeatureBannerMap.set(11, '/quiz');
FeatureBannerMap.set(12, '/weather');
FeatureBannerMap.set(13, '/rapid-trade');
FeatureBannerMap.set(14, '/onboarding');
FeatureBannerMap.set(15, '/creditAccess');
FeatureBannerMap.set(16, '/trades/mySauda');
FeatureBannerMap.set(17, '/kyc');
FeatureBannerMap.set(18, '/ai');

export default FeatureBannerMap;
